import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableComposeExperienceUrls from './tableComposeExperienceUrls';

export default {
  attributeName: 'sponsors',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  isMultiSelectable:true,
  bulkDelete: true,
  canRemove: true,
  editURL: routes.SPONSORS_EDIT,
  createPath: routes.SPONSORS_NEW,
  editURL: routes.SPONSORS_EDIT,

  emptyMessage: "You don't have ingest servers configured yet, click on the +new button to make a new one.",
 fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Id of the event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'80px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the Sponsor',
      default: '',
      canOrder: true,
      canFilter: true,
      width: '15rem',
    },
  ],
};
